import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class DescriptionColumn extends Column {
    title = 'settings.custom-fields.field-index-table.description';
    property = 'description';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
}
